export class ToolTipManagerMobile {
    constructor() {
        if (this.isMobileShop()) {
            this.bindEvents();
            this.triggerInitToolTips();
        }
    }
    bindEvents() {
        window.shell.subscribeTo('AAS.updateFinished', (payload) => {
            this.triggerInitToolTips(payload.querySelector);
        }, 'AAS.update');
    }
    isMobileShop() {
        return document.documentElement.classList.contains('mobileshop');
    }
    triggerInitToolTips(selector = '.scope-aas') {
        const scopeAas = document.querySelector(selector);
        if (scopeAas) {
            this.initToolTips(scopeAas);
        }
    }
    initToolTips(scopeAas) {
        const tooltipContainers = Array.from(scopeAas.querySelectorAll('.aas-tooltip-container'));
        const modal = scopeAas.querySelector('.aas-modal');
        if (!modal)
            return;
        const closeButtons = Array.from(modal.querySelectorAll('.aas-modal-close'));
        closeButtons.forEach((button) => {
            button.addEventListener('click', () => modal.style.display = 'none');
        });
        tooltipContainers.forEach((container) => {
            const infoIcons = Array.from(container.querySelectorAll('svg'));
            const tooltipContent = container.querySelector('.aas-tooltip-content');
            if (!tooltipContent)
                return;
            infoIcons.forEach((icon) => {
                icon.addEventListener('click', () => {
                    const modalContent = modal.querySelector('.aas-modal-content');
                    if (modalContent) {
                        modalContent.innerHTML = tooltipContent.innerHTML;
                        modal.style.display = 'block';
                    }
                });
            });
        });
        window.addEventListener('click', (event) => {
            if (event.target === modal) {
                modal.style.display = 'none';
            }
        });
    }
}
new ToolTipManagerMobile();
